const dialog = {
  namespaced: true,
  state: {
    forgotpassword: false,
    dialoglogin: false,
    homepage: false,
    dialogReferenceNo: false
  },
  mutations: {
    setForgotPasswordVisible: function (state, payload = { visible: true }) {
      state.forgotpassword = payload.visible
    },
    setLoginVisible: function (state, payload = { visible: true }) {
      state.dialoglogin = payload.visible
      state.forgotpassword = null
    },
    setHomepageVisible: function (state, payload = { homepage: false }) {
      state.homepage = payload.homepage
    },
    setReferenceNoVisible: function (state, payload = { dialogReferenceNo: false }) {
      state.dialogReferenceNo = payload.dialogReferenceNo
    }
  }
}

export default dialog
